import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { flatten, sortBy } from 'lodash'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { ScrollableUserList } from 'components/UI'
import { List, Spinner } from 'ui'
import { Format, durationInWords } from 'services/Dates'
import { getUserName } from 'services/Utilities'
import { createErrorNotification } from 'store/actions/notifications'

import { t } from 'translations'

const ContactUsersHistoryModal = ({ filter, limit, listId, listIndex, page }) => {
  const dispatch = useDispatch()
  const { defaultTimeZone: timeZone } = useSelector(state => state.settings)
  const [contactHistory, setContactHistory] = useState([])
  const [users, setUsers] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    async function fetch() {
      setIsLoading(true)
      const skipParam = page ? { skip: (page - 1) * limit } : {}
      const limitParam = limit ? { limit } : {}
      const params = {
        ...filter,
        ...skipParam,
        ...limitParam,
        listId,
        listIndex,
        page,
        useNewReturn: true
      }
      const { result, success } = await Api(`contact/users`, {
        params
      })
      if (!success) dispatch(createErrorNotification())

      // Build an array of all there hisotry
      let contactHistory = flatten(result.map(({ contactHistory = [], userId }) => contactHistory.map(history => ({ ...history, userId }))))

      // Sort the history
      contactHistory = sortBy(contactHistory, ['createdAt'])

      setContactHistory(contactHistory)
      setUsers(result.map(({ userId }) => userId))
      setIsLoading()
    }

    fetch()
  }, [dispatch, filter, limit, listId, listIndex, page])

  return (
    <BaseModal title={`manager.contactLists.CONTACT_USERS_HISTORY_MODAL`}>
      <>
        <h6>{t('manager.contactLists.CONTACT_USERS_HISTORY_MODAL.SEEING_THESE_USERS', { count: users.length })}</h6>
        <ScrollableUserList usersIds={users} />
        <List maxHeight="30rem">
          {contactHistory.map(({ answer, author, callDuration, comment, createdAt, status, userId }, index) => (
            <List.Item key={index} className="d-flex">
              <div>
                <div>
                  <b className="mr-1">{Format(createdAt, { outFormat: 'humanDateTimeLog', isUTC: true, timeZone })}</b>
                </div>
                <div>
                  <span className="mr-1">
                    {t(`manager.contactLists.HISTORY.${answer}`)} / {t(`manager.contactLists.HISTORY.${status}`)}
                  </span>
                  <span className="mr-1">{t('manager.contactLists.HISTORY.BY')}</span>
                  <b>{getUserName(author)}</b>
                </div>
                <div>{comment !== '-' ? <i className="ml-1">{comment}</i> : null}</div>
                <div>{typeof callDuration !== 'undefined' ? <i className="ml-1">{durationInWords(callDuration, { fromSeconds: true })}</i> : null}</div>
              </div>
              <div className="ml-auto">{getUserName(userId)}</div>
            </List.Item>
          ))}
          {isLoading ? (
            <List.Item className="d-flex">
              <Spinner className="mr-1" /> {t('manager.contactLists.CONTACT_USERS_HISTORY_MODAL.LOADING_DATA')}
            </List.Item>
          ) : null}
        </List>
      </>
    </BaseModal>
  )
}

export default ContactUsersHistoryModal
